import React from "react";
import { MenuItem, Select, InputLabel, FormControl, Chip, Box, OutlinedInput } from "@mui/material";

const BrandClip = ({ brands, selectedBrand, setSelectedBrand, brandId }) => {
  const handleSelect = event => {
    const value = event.target.value;
    setSelectedBrand(brands.filter(cat => value.includes(cat.brandId)));
  };

  const handleDelete = id => {
    setSelectedBrand(prevSelected => prevSelected.filter(cat => cat.brandId !== id));
  };

  return (
    <FormControl fullWidth className='select-category'>
      <InputLabel className='select-category-lable'>Product Brand *</InputLabel>
      <Select
        value={selectedBrand.map(cat => cat.brandId)} // Store only IDs in Select
        onChange={handleSelect}
        input={<OutlinedInput label='Product Category *' />}
        className='category-box'
        // multiple
        required
        // renderValue={(selected) => (
        //   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        //     {selectedBrand.map((cat) => (
        //       <Chip key={cat.id} label={cat.name} onDelete={() => handleDelete(cat.id)} />
        //     ))}
        //   </Box>
        // )}
      >
        {/* Individual Category Options */}
        {brands.map(brand => (
          <MenuItem key={brand.brandId} value={brand.brandId}>
            {brand.name}
          </MenuItem>
        ))}
      </Select>

      {/* Show selected categories as removable MUI Chips below the dropdown */}
      <Box mt={2} sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {selectedBrand?.length > 0 &&
          selectedBrand.map(cat => (
            <Chip
              key={cat.brandId}
              label={cat.name}
              style={{ borderRadius: "6px" }}
              onDelete={() => handleDelete(cat.brandId)}
            />
          ))}
      </Box>
    </FormControl>
  );
};

export default BrandClip;
